// extracted by mini-css-extract-plugin
export default {"spinner":"inputs_spinner__bqDuC","centered":"inputs_centered__w+1p9","hidden":"inputs_hidden__V0qEu"};